import tippy from 'tippy.js';

const tooltipItems = document.querySelectorAll<HTMLElement>('.i-tooltip:not(.i-user-address-list__tooltip)');
const userTooltipItems = document.querySelectorAll<HTMLElement>('.i-user-address-list__tooltip');

const loopItems = (items: NodeListOf<HTMLElement>, offset?: [number, number]) => {
  const tippyOffset = offset || [-8, 8]

  items.forEach(item => {
    const target = item.querySelector<HTMLElement>('.i-tooltip__target');
    const content = item.querySelector<HTMLElement>('.i-tooltip__content');

    if(!content || !target) return;

    content.classList.remove("d-none")

    tippy(target, {
      offset: tippyOffset,
      content: content,
      placement: 'bottom-end',
      maxWidth: 'none',
      trigger: 'mouseenter click',
    })
  })
}

loopItems(tooltipItems)
loopItems(userTooltipItems, [17, 8])

